import { Apple, Milk, ShoppingBag, Beef, Tag } from 'lucide-react';

// Default category configurations
const defaultCategoryConfig = {
  'Fruit & Veg': {
    color: '#8FAA96', // Sage green (Figma-aligned)
    icon: Apple
  },
  'Dairy': {
    color: '#6A8DB5', // Muted blue (Figma-aligned)
    icon: Milk
  },
  'Groceries': {
    color: '#A89F9A', // Neutral taupe
    icon: ShoppingBag
  },
  'Meat': {
    color: '#C85534', // Coral/red (Figma-aligned)
    icon: Beef
  },
  'Butcher': {
    color: '#C85534', // Match Meat
    icon: Beef
  },
  'Organic Shop': {
    color: '#CA8A04', // More yellow, similar depth (distinct from reds/greens)
    icon: ShoppingBag
  }
};

// Extended color palette for custom categories (muted, accessible colors)
const customCategoryColors = [
  '#B88E9D', // Dusty rose
  '#8FA8BD', // Soft steel blue
  '#A5B68D', // Olive green
  '#C9A78F', // Warm sand
  '#9B9ECE', // Soft lavender
  '#B39C7D', // Warm taupe
  '#8BAAA0', // Teal sage
  '#C89B9C', // Blush
  '#7C9DAF', // Slate blue
  '#A8A094', // Warm gray
];

// Get category configuration (color + icon)
export function getCategoryConfig(categoryName, customCategoryIndex) {
  // Check if it's a default category
  if (defaultCategoryConfig[categoryName]) {
    return defaultCategoryConfig[categoryName];
  }
  
  // For custom categories, rotate through the custom color palette
  const colorIndex = customCategoryIndex !== undefined 
    ? customCategoryIndex % customCategoryColors.length 
    : 0;
  
  return {
    color: customCategoryColors[colorIndex],
    icon: Tag
  };
}

// Get just the color for a category
export function getCategoryColor(categoryName, customCategoryIndex) {
  return getCategoryConfig(categoryName, customCategoryIndex).color;
}

// Get all default category names
export function getDefaultCategories() {
  return Object.keys(defaultCategoryConfig);
}
